import { createNamespace } from './base'

const send = createNamespace( '/api/doctorlanding/system' )

const SystemApi = {
    GetSettings: ({ lang = "ru", params = { }}) => send({ action: 'get-settings', data: {lang, params} }),
    GetLanding: ({id}) => send({ action: 'get-landing', data: {id} })
}

export default SystemApi